/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { routes } from "@bvi/admin-panel/api-routes";
import { apiContainer, getItemTags, getListTag, invalidateTags, provideTagsList, TagTypes, WithId } from "@bvi/admin-panel/shared/api";
import { getResponseData } from "@bvi/api-interfaces/response";
import {
  IOrganizationTypeListResponse,
  IOrganizationTypeResponse
} from '@bvi/api-interfaces/response/manage-base-data';
import { ICreateOrganizationTypeRequest } from "@bvi/api-interfaces/request/organization-type";

export const organizationTypeApi = apiContainer.injectEndpoints({
  endpoints: (builder) => ({
    getOrganizationTypeList: builder.query<IOrganizationTypeListResponse, void>({
      query: () => ({
        url: routes.organizationType.findAll(),
        method: 'GET',
      }),
      providesTags: (result) =>
        result
          ? [
            ...getItemTags(TagTypes.ORGANIZATION_TYPE, getResponseData(result)),
            getListTag(TagTypes.ORGANIZATION_TYPE),
          ]
          : [getListTag(TagTypes.ORGANIZATION_TYPE)],
    }),

    getByIdOrganizationType: builder.query<IOrganizationTypeResponse, number>({
      query: (id) => ({
        url: routes.organizationType.findOne(),
        method: 'GET',
        params: { id },
      }),
      providesTags: provideTagsList(TagTypes.ORGANIZATION_TYPE)
    }),

    createOrganizationType: builder.mutation<
      IOrganizationTypeResponse,
      ICreateOrganizationTypeRequest
    >({
      query: (data) => ({
        url: routes.organizationType.create(),
        method: 'POST',
        data,
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.ORGANIZATION_TYPE)),
    }),

    updateOrganizationType: builder.mutation<
      IOrganizationTypeResponse,
      WithId<ICreateOrganizationTypeRequest>
    >({
      query: ([id, data]) => ({
        url: routes.organizationType.update(),
        method: 'PUT',
        data: { id, name: data.name },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.ORGANIZATION_TYPE)),
    }),

    deleteOrganizationType: builder.mutation<void, number>({
      query: (id) => ({
        url: routes.organizationType.remove(),
        method: 'DELETE',
        params: { id },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.ORGANIZATION_TYPE)),
    }),
  }),
});

export const {
  useGetOrganizationTypeListQuery,
  useLazyGetOrganizationTypeListQuery,
  useGetByIdOrganizationTypeQuery,
  useLazyGetByIdOrganizationTypeQuery,
  useCreateOrganizationTypeMutation,
  useUpdateOrganizationTypeMutation,
  useDeleteOrganizationTypeMutation
} = organizationTypeApi;

